// https://wiki.one.int.sap/wiki/display/CONUX/Person+Name+Localization
export var formatEmployeeNameSalutation = function (formatters, _a) {
    var firstName = _a.firstName, lastName = _a.lastName, preferredName = _a.preferredName, _b = _a.includeComma, includeComma = _b === void 0 ? true : _b;
    var locale = formatters.preferences.locale;
    var lowerCaseLang = locale.toLowerCase();
    var comma = includeComma ? ', ' : '';
    if (preferredName && !['ko', 'ja', 'ms', 'th', 'vi', 'sk', 'sl'].includes(lowerCaseLang)) {
        if ([
            'cs',
            'da',
            'en',
            'en-gb',
            'de',
            'el',
            'es-la',
            'fr',
            'fr-ca',
            'hr',
            'hu',
            'es',
            'id',
            'it',
            'nl',
            'no',
            'pl',
            'pt-br',
            'ro',
            'ru',
            'sv',
            'tr',
            'uk',
            'zh-cn',
            'zh-tw',
        ].includes(lowerCaseLang)) {
            return "".concat(comma).concat(preferredName);
        }
    }
    if (['ja'].includes(lowerCaseLang)) {
        return "".concat(comma).concat(firstName, "\u3055\u3093");
    }
    if (['ko'].includes(lowerCaseLang)) {
        return "".concat(comma).concat(firstName, "\uB2D8");
    }
    if (['ms', 'es-la', 'th', 'vi', 'sl'].includes(lowerCaseLang)) {
        return "".concat(comma).concat(firstName, " ").concat(lastName);
    }
    return "".concat(comma).concat(firstName);
};
